// @ts-nocheck

import { Route as rootRoute } from '../routes/__root';
import { Route as AdminProfileReviewsRoute } from '../routes/admin/profile-reviews';
import { Route as ArtistClaimRoute } from '../routes/artist-claim';
import { Route as AuthRegisterRoute } from '../routes/auth/register';
import { Route as AuthVerifyRoute } from '../routes/auth/verify';
import { Route as DashboardArtworksRoute } from '../routes/dashboard/artworks';
import { Route as DashboardArtworkIdRoute } from '../routes/dashboard/artworks.$artworkId';
import { Route as DashboardArtworksNewRoute } from '../routes/dashboard/artworks.new';
import { Route as DashboardEscrowSaleIdRoute } from '../routes/dashboard/escrow.$saleId';
import { Route as DashboardIndexRoute } from '../routes/dashboard/index';
import { Route as DashboardProfileRoute } from '../routes/dashboard/profile';
import { Route as DashboardPurchasesRoute } from '../routes/dashboard/purchases';
import { Route as DashboardSalesRoute } from '../routes/dashboard/sales';

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin/profile-reviews': {
      id: '/admin/profile-reviews';
      path: '/admin/profile-reviews';
      fullPath: '/admin/profile-reviews';
      preLoaderRoute: typeof AdminProfileReviewsRoute;
      parentRoute: typeof rootRoute;
    };
    '/artist-claim': {
      id: '/artist-claim';
      path: '/artist-claim';
      fullPath: '/artist-claim';
      preLoaderRoute: typeof ArtistClaimRoute;
      parentRoute: typeof rootRoute;
    };
    '/auth/register': {
      id: '/auth/register';
      path: '/auth/register';
      fullPath: '/auth/register';
      preLoaderRoute: typeof AuthRegisterRoute;
      parentRoute: typeof rootRoute;
    };
    '/auth/verify': {
      id: '/auth/verify';
      path: '/auth/verify';
      fullPath: '/auth/verify';
      preLoaderRoute: typeof AuthVerifyRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/': {
      id: '/dashboard/';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof DashboardIndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/artworks': {
      id: '/dashboard/artworks';
      path: '/dashboard/artworks';
      fullPath: '/dashboard/artworks';
      preLoaderRoute: typeof DashboardArtworksRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/artworks/new': {
      id: '/dashboard/artworks/new';
      path: '/dashboard/artworks/new';
      fullPath: '/dashboard/artworks/new';
      preLoaderRoute: typeof DashboardArtworksNewRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/artworks/$artworkId': {
      id: '/dashboard/artworks/$artworkId';
      path: '/dashboard/artworks/$artworkId';
      fullPath: '/dashboard/artworks/$artworkId';
      preLoaderRoute: typeof DashboardArtworkIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/profile': {
      id: '/dashboard/profile';
      path: '/dashboard/profile';
      fullPath: '/dashboard/profile';
      preLoaderRoute: typeof DashboardProfileRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/sales': {
      id: '/dashboard/sales';
      path: '/dashboard/sales';
      fullPath: '/dashboard/sales';
      preLoaderRoute: typeof DashboardSalesRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/purchases': {
      id: '/dashboard/purchases';
      path: '/dashboard/purchases';
      fullPath: '/dashboard/purchases';
      preLoaderRoute: typeof DashboardPurchasesRoute;
      parentRoute: typeof rootRoute;
    };
    '/dashboard/escrow/$saleId': {
      id: '/dashboard/escrow/$saleId';
      path: '/dashboard/escrow/$saleId';
      fullPath: '/dashboard/escrow/$saleId';
      preLoaderRoute: typeof DashboardEscrowSaleIdRoute;
      parentRoute: typeof rootRoute;
    };
  }
}

const AdminProfileReviewsRouteWithChildren = AdminProfileReviewsRoute.update({
  id: '/admin/profile-reviews',
  path: '/admin/profile-reviews',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/profile-reviews.lazy').then((d) => d.Route));

const ArtistClaimRouteWithChildren = ArtistClaimRoute.update({
  id: '/artist-claim',
  path: '/artist-claim',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/artist-claim.lazy').then((d) => d.Route));

const AuthRegisterRouteWithChildren = AuthRegisterRoute.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/auth/register.lazy').then((d) => d.Route));

const AuthVerifyRouteWithChildren = AuthVerifyRoute.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/auth/verify.lazy').then((d) => d.Route));

const DashboardIndexRouteWithChildren = DashboardIndexRoute.update({
  id: '/dashboard/',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/index.lazy').then((d) => d.Route));

const DashboardArtworksRouteWithChildren = DashboardArtworksRoute.update({
  id: '/dashboard/artworks',
  path: '/dashboard/artworks',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/artworks.lazy').then((d) => d.Route));

const DashboardArtworksNewRouteWithChildren = DashboardArtworksNewRoute.update({
  id: '/dashboard/artworks/new',
  path: '/dashboard/artworks/new',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/artworks.new.lazy').then((d) => d.Route));

const DashboardArtworkIdRouteWithChildren = DashboardArtworkIdRoute.update({
  id: '/dashboard/artworks/$artworkId',
  path: '/dashboard/artworks/$artworkId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/artworks.$artworkId.lazy').then((d) => d.Route));

const DashboardProfileRouteWithChildren = DashboardProfileRoute.update({
  id: '/dashboard/profile',
  path: '/dashboard/profile',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/profile.lazy').then((d) => d.Route));

const DashboardSalesRouteWithChildren = DashboardSalesRoute.update({
  id: '/dashboard/sales',
  path: '/dashboard/sales',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/sales.lazy').then((d) => d.Route));

const DashboardPurchasesRouteWithChildren = DashboardPurchasesRoute.update({
  id: '/dashboard/purchases',
  path: '/dashboard/purchases',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/purchases.lazy').then((d) => d.Route));

const DashboardEscrowSaleIdRouteWithChildren = DashboardEscrowSaleIdRoute.update({
  id: '/dashboard/escrow/$saleId',
  path: '/dashboard/escrow/$saleId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/dashboard/escrow.$saleId.lazy').then((d) => d.Route));

export const ownerChildren = {
  AdminProfileReviewsRoute: AdminProfileReviewsRouteWithChildren,
  ArtistClaimRoute: ArtistClaimRouteWithChildren,
  AuthRegisterRoute: AuthRegisterRouteWithChildren,
  AuthVerifyRoute: AuthVerifyRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRouteWithChildren,
  DashboardArtworksRoute: DashboardArtworksRouteWithChildren,
  DashboardArtworksNewRoute: DashboardArtworksNewRouteWithChildren,
  DashboardArtworkIdRoute: DashboardArtworkIdRouteWithChildren,
  DashboardProfileRoute: DashboardProfileRouteWithChildren,
  DashboardSalesRoute: DashboardSalesRouteWithChildren,
  DashboardPurchasesRoute: DashboardPurchasesRouteWithChildren,
  DashboardEscrowSaleIdRoute: DashboardEscrowSaleIdRouteWithChildren,
};
